import { Label, Select } from "@a7y/tailwind-catalyst";
import * as Headless from "@headlessui/react";
import type { ChangeEvent } from "react";

/**
 * Canonical sender identity labels used across all email admin pages.
 * Import this constant for display-only contexts (tables, detail views, confirm dialogs).
 */
// eslint-disable-next-line react-refresh/only-export-components
export const SENDER_IDENTITY_LABELS: Record<string, string> = {
  team: "The Apptonomy Team",
  tpf: "TPF (CEO/Co-founder)",
  yevhen: "Yevhen (CMO/Co-founder)",
};

interface SenderIdentitySelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/**
 * Shared sender identity dropdown for email compose forms.
 * Works with both SenderIdentity and ProductEmailSenderIdentity types
 * (they are identical string unions).
 */
export function SenderIdentitySelect({
  value,
  onChange,
  className,
}: SenderIdentitySelectProps) {
  return (
    <Headless.Field className={className}>
      <Label>Sender Identity</Label>
      <Select
        className="mt-2"
        value={value}
        onChange={(e: ChangeEvent<HTMLSelectElement>) =>
          onChange(e.target.value)
        }
      >
        {Object.entries(SENDER_IDENTITY_LABELS).map(([k, label]) => (
          <option key={k} value={k}>
            {label}
          </option>
        ))}
      </Select>
    </Headless.Field>
  );
}
